import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NewSectionBlockForm from 'component/sectionBlock/NewSectionBlockForm'
import CloseIconSVG from 'component/svgComponents/close'

class SideFilterForm extends Component {
  state = {
    values: {},
  }

  handleSubmit = () => {
    const { submit } = this.props
    const { values } = this.state

    submit && submit(values)
  }

  render() {
    const { setSideFilterVisible = () => {}, options, shown } = this.props

    return (
      <div className={`right-filter-container ${!shown ? 'hidden' : ''}`}>
        <CloseIconSVG className="right-filter-svg" onClick={setSideFilterVisible} />
        <h3 className='margin-bottom-triple'>
          <strong>Filtro</strong>
        </h3>
        <NewSectionBlockForm
          options={options}
          onChange={(values) => this.setState({ values })}
        />
        <button
          className='btn btn-primary button-full'
          onClick={this.handleSubmit}
          type='button'
        >
          Filtrar
        </button>
      </div>
    )
  }
}

SideFilterForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  shown: PropTypes.bool,
}

export default SideFilterForm

export { SideFilterForm }
